import React from 'react';

const StatCard = ({ icon, title, value, color = '#9c27b0', subtitle }) => {
  const formatValue = (val) => {
    if (typeof val === 'number') {
      if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M';
      if (val >= 1000) return (val / 1000).toFixed(1) + 'K';
      return val.toLocaleString();
    }
    return val;
  };

  return (
    <div style={{
      background: 'white',
      borderRadius: '16px',
      padding: '20px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      transition: 'transform 0.2s, box-shadow 0.2s',
      cursor: 'default'
    }}
    onMouseEnter={e => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.12)';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)';
    }}
    >
      <div style={{
        width: '50px',
        height: '50px',
        borderRadius: '12px',
        background: `linear-gradient(135deg, ${color}, ${color}dd)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px'
      }}>
        {icon}
      </div>
      <div>
        <div style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#333',
          lineHeight: 1.2
        }}>
          {formatValue(value)}
        </div>
        <div style={{
          fontSize: '13px',
          color: '#666',
          marginTop: '4px'
        }}>
          {title}
        </div>
        {subtitle && (
          <div style={{
            fontSize: '11px',
            color: '#999',
            marginTop: '2px'
          }}>
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
